<script setup lang="ts">
import type { ProductAliases } from '~/config'

const { LocalConfigurationStore } = stores()

const code = useRouteParams<ProductAliases | null>('code', null)

onBeforeMount(() => {
  if (code.value) {
    const avaliableProducts = LocalConfigurationStore?.value?.productsInfo?.map((p) => p.code) ?? []

    if (avaliableProducts.includes(code.value)) return

    showError({
      statusCode: 404,
      statusMessage: 'Página no encontrada',
    })
  }
})
</script>

<template>
  <div class="flex flex-col justify-stretch gap-12 md:gap-14">
    <ContentBanner />
    <ContentProductList :initial-product="code" />
    <ContentHighlights />
    <ContentCompanyList />
  </div>
</template>
